import api from "../../../utils/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { RootState } from "../../rootReducer";
import axiosInstance from "../../../utils/axiosConfig";

const findNotifications = createAsyncThunk(
  "notificationsList/find",
  async (filter, { getState, rejectWithValue }) => {
    try {
      const state = getState() as RootState;

      const { data } = await axiosInstance.get(`${api.baseURL}notification`, {
        params: {
          where: {
            assignedTo: state.userAuthentication.user?.id,
           // sourceOrganization: state.userAuthentication.user?.sourceOrganization,
          },
          sort: "createdAt DESC",
        },
      });
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export default findNotifications;
